/*global jQuery, BulkWP*/
jQuery(document).ready(function () {
	BulkWP.enableHelpTooltips( jQuery( '.bd-help' ) );
});

BulkWP.enableHelpTooltips = function ( $selector ) {
	$selector.tooltip({
		content: function() {
			return jQuery(this).prop('title');
		},
		position: {
			my: 'center top',
			at: 'center bottom+10',
			collision: 'flipfit'
		},
		hide: {
			duration: 200
		},
		show: {
			duration: 200
		}
	});
};
